import { useState, useEffect } from "react";
import { useGetAdsOne } from "../functions/homeAds.ts";

const COLOR_THEMES = [
    {
        background: 'linear-gradient(145deg, #1e3a8a 0%, #1c3d6e 100%)',
        border: '#334E7D',
        accent: '#001f3f',
        buttonFrom: '#001f3f',
        buttonTo: '#1e3a8a'
    },
    {
        background: 'linear-gradient(145deg, #059669 0%, #047857 100%)',
        border: '#34D399',
        accent: '#065F46',
        buttonFrom: '#065F46',
        buttonTo: '#059669'
    },
    {
        background: 'linear-gradient(145deg, #7C3AED 0%, #6D28D9 100%)',
        border: '#8B5CF6',
        accent: '#5B21B6',
        buttonFrom: '#5B21B6',
        buttonTo: '#7C3AED'
    },
    {
        background: 'linear-gradient(145deg, #DC2626 0%, #B91C1C 100%)',
        border: '#EF4444',
        accent: '#7F1D1D',
        buttonFrom: '#7F1D1D',
        buttonTo: '#DC2626'
    }
];

const getRandomTheme = (seed: string) => {
    const hash = seed.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
    return COLOR_THEMES[hash % COLOR_THEMES.length];
};

const FloatingAdTwo = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [hasShown, setHasShown] = useState(false);
    const [lastClosedTime, setLastClosedTime] = useState<number>(0);
    const [currentTheme, setCurrentTheme] = useState(COLOR_THEMES[0]);
    // @ts-expect-error
    const { ads, isLoading,  } = useGetAdsOne();

    const adsArray = Array.isArray(ads) ? ads : [ads];
    const ad = adsArray[0];

    useEffect(() => {
        const savedTime = localStorage.getItem('adLastClosedTime');
        if (savedTime) setLastClosedTime(parseInt(savedTime));
    }, []);

    useEffect(() => {
        if (ad?._id) {
            setCurrentTheme(getRandomTheme(ad._id));
        }
    }, [ad?._id]);

    useEffect(() => {
        const handleScroll = () => {
            if (!hasShown) {
                const scrollPosition = window.scrollY + window.innerHeight;
                const pageHeight = document.documentElement.scrollHeight;

                if (scrollPosition > pageHeight * 0.5) {
                    const currentTime = Date.now();
                    if (currentTime - lastClosedTime > 300000) {
                        showAd();
                        window.removeEventListener('scroll', handleScroll);
                    }
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [hasShown, lastClosedTime]);

    const showAd = () => {
        setIsVisible(true);
        setHasShown(true);
    };

    const handleClose = () => {
        const closeTime = Date.now();
        localStorage.setItem('adLastClosedTime', closeTime.toString());
        setLastClosedTime(closeTime);
        setIsVisible(false);
    };

    const handleClick = () => {
        window.open(ad?.link, "_blank");
    };

    if (!isVisible || !ad) return null;

    return (
        <div
            className={`fixed md:left-6 left-2 bottom-2 md:bottom-6 shadow-2xl rounded-xl md:p-5 p-3 
          md:w-72 w-56 z-[20000] transition-all duration-500 
          ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
            style={{
                background: currentTheme.background,
                border: `1px solid ${currentTheme.border}`
            }}
        >
            <button
                className="absolute top-1 right-1 md:top-2 md:right-2 bg-white/10 hover:bg-white/20 text-white rounded-full
            w-5 h-5 md:w-6 md:h-6 flex items-center justify-center shadow-lg transition-colors duration-200"
                onClick={handleClose}
            >
                <span className="text-xs md:text-sm leading-none">×</span>
            </button>

            <div className="absolute top-0 left-0 right-0 h-1 rounded-t-xl"
                 style={{ backgroundColor: currentTheme.accent }} />

            <div className="space-y-2 md:space-y-4 mt-1 md:mt-2">
                {isLoading ? (
                    <div className="space-y-4 animate-pulse">
                        <div className="h-6 bg-white/20 rounded w-3/4 mx-auto" />
                        <div className="h-4 bg-white/20 rounded w-5/6 mx-auto" />
                        <div className="h-32 bg-white/20 rounded-lg" />
                        <div className="h-10 bg-white/20 rounded-lg" />
                    </div>
                ) : (
                    <>
                        <div className="text-center space-y-1 md:space-y-3">
                            <h3 className="font-semibold md:text-xl text-lg text-white tracking-tight">
                                {ad.title}
                            </h3>
                            <p className="text-xs md:text-sm text-gray-200 leading-relaxed">
                                {ad.description}
                            </p>
                        </div>

                        <div className="relative group overflow-hidden rounded-lg"
                             style={{ border: `2px solid ${currentTheme.border}` }}>
                            <img
                                src={ad.image}
                                alt="Advertisement"
                                className="w-full md:h-40 h-32 object-cover transform transition-transform
                    duration-300 group-hover:scale-105"
                            />
                        </div>

                        <button
                            onClick={handleClick}
                            className="w-full text-white font-medium md:py-3 py-2 rounded-lg shadow-md hover:shadow-lg
                  transition-all duration-300 flex items-center justify-center space-x-2 text-sm md:text-base"
                            style={{
                                background: `linear-gradient(to right, ${currentTheme.buttonFrom}, ${currentTheme.buttonTo})`
                            }}
                        >
                            <span>Learn More</span>
                            <svg className="w-3 h-3 md:w-4 md:h-4 fill-current" viewBox="0 0 24 24">
                                <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
                            </svg>
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};

export default FloatingAdTwo;